import { render, staticRenderFns } from "./PainterMsgDetails.vue?vue&type=template&id=6d557be4&scoped=true"
import script from "./PainterMsgDetails.vue?vue&type=script&lang=js"
export * from "./PainterMsgDetails.vue?vue&type=script&lang=js"
import style0 from "./PainterMsgDetails.vue?vue&type=style&index=0&id=6d557be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d557be4",
  null
  
)

export default component.exports